import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PaystackPop from "@paystack/inline-js";

import { Container, Col, Row } from "reactstrap";
import { IonButton} from '@ionic/react';
import _ from "lodash";
import {
  showLoading,
  fetchBillingDetails,
  fetchUser,
  fetchSettings,
  initializePaystackTransaction,
  cancelCardSubscription,
} from '../../redux/actions';

import {
  check_empty_field,
  check_if_positive_number,
  check_if_whole_number,
  check_if_number_greater_than_100,
} from "./validationChecks";
// Define payment items
const SUBSCRIPTION_PAYMENT_ITEM = "subscription";
const SMS_PAYMENT_ITEM = "sms";
// Define payment options for subscription
const SUBSCRIPTION_PAYMENT_OPTIONS = {
  currentBalance: "currentBalance",
  customAmount: "customAmount",
  balancePlusNextMonth: "balancePlusNextMonth",
};

const mapDispatchToProps = {
  fetchBillingDetails,
  showLoading,
  initializePaystackTransaction,
  fetchUser,
  fetchSettings,
  cancelCardSubscription,
};

const mapStateToProps = (state) => {
  return {
    billing: state.billing,
    user: state.user,
    settings: state.settings,
    paystack: state.paystack,
  };
};

class PaystackForm extends React.Component {
  constructor(props) {
    super(props);
    let payment = {
      amount: 0,
      subscriptionBalance: 0,
      subscriptionCost: 0,
      hasActiveSubscription: false,
    };
    this.state = {
      ...payment,
      paymentItem: SUBSCRIPTION_PAYMENT_ITEM,
      subscriptionOption: SUBSCRIPTION_PAYMENT_OPTIONS.currentBalance,
      numErrors: 0,
      errors: {
        amount: "",
        paymentItem: "",
      },
    };
    this.handlePaymentOptionChange = this.handlePaymentOptionChange.bind(this);
    this.handleSubscriptionOptionChange =
      this.handleSubscriptionOptionChange.bind(this);
    this.handleCustomBalanceChange = this.handleCustomBalanceChange.bind(this);
  }

  updateCustomerBillingDetails() {
    let account = null;
    let subscriptionBalance = 0;
    let subscriptionCost = 0;
    let hasActiveSubscription = false;
    if (this.props.billing && this.props.billing.customerAccount) {
      account = this.props.billing.customerAccount;
      subscriptionBalance = account.subscriptionBalance
        ? parseFloat(account.subscriptionBalance)
        : 0;
      subscriptionCost = parseFloat(
        account.subscriptionCost.replace(/[^\d.]/g, "")
      );
      hasActiveSubscription = account.hasActiveCardSubscription;
      this.setState({
        ...this.state,
        subscriptionBalance,
        subscriptionCost,
        hasActiveSubscription,
      });
    }
  }

  async componentDidMount() {
    await this.props.fetchBillingDetails();
    if (_.isEmpty(this.props.settings)) {
      this.props.showLoading(true);
      await this.props.fetchSettings();
    }
    if (_.isEmpty(this.props.user)) {
      const action = await this.props.fetchUser();
      userId = action.payload.user.userId;
    }
    this.updateCustomerBillingDetails();
  }

  async validateInput(name, value) {
    let val = String(value);
    let isValid = true;
    let checks = [];

    switch (name) {
      case "amount":
        checks = [
          check_empty_field,
          check_if_positive_number,
          check_if_whole_number,
          check_if_number_greater_than_100,
        ];
        break;
      default:
        break;
    }

    await new Promise((resolve) => {
      this.setState((prevState) => {
        let errors = { ...prevState.errors };
        let numErrors = prevState.numErrors;
        for (let index in checks) {
          let previousError = prevState.errors[name];
          errors[name] = checks[index](val);
          if (errors[name].length > 0) {
            if (previousError.length == 0) {
              numErrors += 1;
            }
            isValid = false;
            break;
          } else if (previousError.length > 0) {
            numErrors -= 1;
          }
        }
        return {
          errors,
          numErrors,
        };
      }, resolve);
    });
    return isValid;
  }

  async handleCancelSubscription(event) {
    event.preventDefault();
    this.props.showLoading(true);
    await this.props.cancelCardSubscription();
  }

  async handleSubmit(event) {
    event.preventDefault();
    let results = [];
    let fields = [];
    if (
      this.state.subscriptionOption ===
      SUBSCRIPTION_PAYMENT_OPTIONS.customAmount
    ) {
      fields = ["amount"];
    }
    let field;
    for (field of fields) {
      let isValid = await this.validateInput(field, this.state[field]);
      results.push(isValid);
    }
    let invalid_fields = results.filter((x) => !x);
    if (invalid_fields.length == 0) {
      let initializeObj = {
        amount: parseInt(this.state.amount),
        paymentItem: this.state.paymentItem,
      };
      this.props.showLoading(true);
      await this.props.initializePaystackTransaction(initializeObj);
    }
  }
  async componentDidUpdate(prevProps) {
    if (this.props.paystack !== prevProps.paystack) {
      let accessCode = this.props.paystack.accessCode;
      if (accessCode) {
        const paystackPopup = new PaystackPop();
        paystackPopup.resumeTransaction(accessCode);
      }
    }
    if (this.props.billing !== prevProps.billing) {
      this.updateCustomerBillingDetails();
    }
  }

  handlePaymentOptionChange(event) {
    let paymentItem = event.target.value;
    this.setState({
      paymentItem: paymentItem,
      subscriptionOption:
        paymentItem === SMS_PAYMENT_ITEM
          ? SUBSCRIPTION_PAYMENT_OPTIONS.customAmount
          : SUBSCRIPTION_PAYMENT_OPTIONS.currentBalance,
      amount:
        paymentItem === SMS_PAYMENT_ITEM ? 0 : this.state.subscriptionBalance,
    });
  }

  handleSubscriptionOptionChange(event) {
    const value = event.target.value;
    const id = event.target.id;
    let subscriptionOption = "";

    if (id === SUBSCRIPTION_PAYMENT_OPTIONS.customAmount) {
      subscriptionOption = SUBSCRIPTION_PAYMENT_OPTIONS.customAmount;
    } else if (id === SUBSCRIPTION_PAYMENT_OPTIONS.balancePlusNextMonth) {
      subscriptionOption = SUBSCRIPTION_PAYMENT_OPTIONS.balancePlusNextMonth;
    } else {
      subscriptionOption = SUBSCRIPTION_PAYMENT_OPTIONS.currentBalance;
    }

    this.setState({
      subscriptionOption: subscriptionOption,
      amount: parseInt(value),
    });

    if (
      event.target.name === "paymentOption" &&
      event.target.value === SUBSCRIPTION_PAYMENT_OPTIONS.customAmount
    ) {
      // if the custom payment option is selected, set the amount to the custom balance input value
      const customBalanceInput = document.querySelector(
        'input[name="customBalance"]'
      );
      const customBalanceValue = parseInt(customBalanceInput.value);
      if (!isNaN(customBalanceValue)) {
        this.setState({
          amount: customBalanceValue,
        });
      }
    }
  }

  handleCustomBalanceChange(event) {
    const value = event.target.value;
    this.setState({
      amount: value,
    });
    this.validateInput("amount", value);
  }

  async handleBackButton(event) {
    event.preventDefault();
    this.props.history.goBack();
  }

  renderCustomAmountOption() {
    return (
      <>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="paymentOption"
            id={SUBSCRIPTION_PAYMENT_OPTIONS.customAmount}
            value={SUBSCRIPTION_PAYMENT_OPTIONS.customAmount}
            checked={
              this.state.subscriptionOption ===
              SUBSCRIPTION_PAYMENT_OPTIONS.customAmount
            }
            onChange={this.handleSubscriptionOptionChange}
          />
          <label
            className="form-check-label"
            htmlFor={SUBSCRIPTION_PAYMENT_OPTIONS.customAmount}
          >
            Custom Amount
          </label>
        </div>

        {/* Custom amount input field */}
        <div className="container">
          <div className="row justify-content-start">
            <div className="col-12 col-md-6 col-lg-4">
              <input
                type="number"
                min={100}
                name="customBalance"
                className="form-control mt-2"
                placeholder="Enter custom amount"
                onChange={this.handleCustomBalanceChange}
                onClick={() =>
                  this.setState({
                    subscriptionOption:
                      SUBSCRIPTION_PAYMENT_OPTIONS.customAmount,
                  })
                }
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  renderSubcriptionPaymentOptions() {
    return (
      <>
        {/* radio for selecting amount paid */}

        <div className="form-group">
          {/* Stack the form-check items vertically */}
          <div className="d-flex flex-column">
            {/* Select current balance as payment */}
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentOption"
                id={SUBSCRIPTION_PAYMENT_OPTIONS.currentBalance}
                value={this.state.subscriptionBalance}
                checked={
                  this.state.subscriptionOption ===
                  SUBSCRIPTION_PAYMENT_OPTIONS.currentBalance
                }
                onChange={this.handleSubscriptionOptionChange}
              />
              <label
                className="form-check-label"
                htmlFor={SUBSCRIPTION_PAYMENT_OPTIONS.currentBalance}
              >
                Current Balance (Kshs {this.state.subscriptionBalance})
              </label>
            </div>

            {/* Select current balance + next month as payment */}
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentOption"
                id={SUBSCRIPTION_PAYMENT_OPTIONS.balancePlusNextMonth}
                value={
                  this.state.subscriptionBalance + this.state.subscriptionCost
                }
                checked={
                  this.state.subscriptionOption ===
                  SUBSCRIPTION_PAYMENT_OPTIONS.balancePlusNextMonth
                }
                onChange={this.handleSubscriptionOptionChange}
              />
              <label
                className="form-check-label"
                htmlFor={SUBSCRIPTION_PAYMENT_OPTIONS.balancePlusNextMonth}
              >
                Balance plus next month (Kshs{" "}
                {this.state.subscriptionBalance + this.state.subscriptionCost})
              </label>
            </div>

            {/* Custom amount as payment */}
            {this.renderCustomAmountOption()}
          </div>
        </div>
      </>
    );
  }

  renderSMSPaymentOptions() {
    return (
      <>
        {/* radio for selecting amount paid */}
        {this.renderCustomAmountOption()}
      </>
    );
  }

  renderSubscriptionInstructions() {
    return (
      <Container className="p-2">
        <h5>Select the item to pay for </h5>
        {/* radio for selecting subscription or sms */}
        <div className="form-group">
        <div className="d-flex flex-column">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="subscription-sms"
              id="subscription"
              value={SUBSCRIPTION_PAYMENT_ITEM}
              checked={this.state.paymentItem === SUBSCRIPTION_PAYMENT_ITEM}
              onChange={this.handlePaymentOptionChange}
            />
            <label className="form-check-label" htmlFor="subscription">
              Subscription
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="subscription-sms"
              id="sms"
              value={SMS_PAYMENT_ITEM}
              checked={this.state.paymentItem === SMS_PAYMENT_ITEM}
              onChange={this.handlePaymentOptionChange}
            />
            <label className="form-check-label" htmlFor="sms">
              SMS
            </label>
          </div>
        </div>
        </div>

        {/* title for amount to be paid */}
        <h5 style={{ margin: "1em 0" }}>Select the amount to pay</h5>
        {/* radio for selecting amount paid */}
        {this.state.paymentItem === SUBSCRIPTION_PAYMENT_ITEM
          ? this.renderSubcriptionPaymentOptions()
          : this.renderSMSPaymentOptions()}

        {/* display error for incorrect custom value inputs */}
        {this.state.errors.amount &&
          this.state.subscriptionOption ===
            SUBSCRIPTION_PAYMENT_OPTIONS.customAmount && (
            <p className="text-danger">
              <small>{this.state.errors.amount}</small>
            </p>
          )}
        <p className="font-weight-bold">
          Payments are securely processed by a trusted third-party gateway that
          protects your card details.
        </p>

        {/* button for paying */}
        <Row className="mb-2">
          <Col
            lg={10}
            md={11}
            sm={12}
            xs={12}
            className="d-flex flex-column flex-md-row"
          >
            <IonButton
              type="submit"
              className="shadow mt-2 w-100 mx-md-2"
              id="BackPayInstructions"
              size="lg"
              disabled={this.state.numErrors > 0}
              onClick={this.handleSubmit.bind(this)}
            >
              {this.state.paymentItem === SUBSCRIPTION_PAYMENT_ITEM
                ? "Subscribe"
                : "Purchase"}
            </IonButton>

            {this.state.paymentItem === SUBSCRIPTION_PAYMENT_ITEM &&
              this.state.hasActiveSubscription && (
                <IonButton
                  className="shadow mt-2 w-100 mx-md-2"
                  size="lg"
                  fill="outline"
                  onClick={this.handleCancelSubscription.bind(this)}
                >
                  Cancel Subscription
                </IonButton>
              )}
          </Col>
        </Row>

        <Row className="mt-5">
          <h5>
            If you are experiencing problems paying please reach out to customer
            support by email <b>newton@bomahut.com</b> or phone{" "}
            <b>+254 717 512 483</b>. We apologize for any inconvenience.
          </h5>
        </Row>
      </Container>
    );
  }
  render() {
    return (
        <div>
          {this.renderSubscriptionInstructions()}
        </div>

    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PaystackForm)
);
